import S3Uploader, { states } from '@/lib/S3Uploader'

export default {
  data() {
    return {
      upload: {
        error: null,
        inProgress: false,
        preparing: false,
        progressPercent: 0,
      },
    }
  },

  created() {
    this.uploader = new S3Uploader(this.podcastId)
    this.uploader.addEventListener('state', this.handleUploaderEvent)
  },

  methods: {
    uploadFile(file) {
      this.upload.error = null
      return this.uploader.upload(
        file,
        this.$store.state.user.profile.token,
        this.$route.params.tenant,
      )
    },

    handleUploaderEvent(event) {
      switch (event.detail.state) {
        case states.PREPARE:
          this.upload.inProgress = true
          this.upload.preparing = true
          break
        case states.START:
          this.upload.preparing = false
          this.upload.progressPercent = 0
          break
        case states.PROGRESS:
          this.upload.progressPercent = event.detail.progress
          break
        case states.END:
          this.upload.progressPercent = 100
          this.upload.inProgress = false
          break
        case states.ERROR:
          this.upload.inProgress = false
          this.upload.preparing = false
          this.upload.error = event.detail.error
          break
      }
    },
  },
}
